// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labelCss_l9rgqol{cursor:pointer;height:32px;padding:8px 11px;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/chip/ChoiceChip.css"],"names":[],"mappings":"AAAA,kBAAkB,cAAc,CAAC,WAAW,CAAC,gBAAgB,CAAC","sourcesContent":[".labelCss_l9rgqol{cursor:pointer;height:32px;padding:8px 11px;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
